// extracted by mini-css-extract-plugin
export var banner = "Banner_banner__2e-q-";
export var container = "Banner_container__lFIYC";
export var secondaryButton = "Banner_secondaryButton__6LZ9D";
export var themeDark = "Banner_themeDark__D9C+z";
export var themeDarkTransparent = "Banner_themeDarkTransparent__hdVGO";
export var themeLight = "Banner_themeLight__dVpsJ";
export var themeLightTransparent = "Banner_themeLightTransparent__O9+KK";